import { render } from "./TbHeader.vue?vue&type=template&id=4b8f32d7&scoped=true"
import script from "./TbHeader.vue?vue&type=script&lang=js"
export * from "./TbHeader.vue?vue&type=script&lang=js"

import "./TbHeader.vue?vue&type=style&index=0&id=4b8f32d7&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b8f32d7"]])

export default __exports__